export default function getFormatNumber(num: number) {
  if(!num) return num.toString()
  
  if (num >= 1000000) {
    const value = (num / 1000000);
    return value % 1 === 0 ? `${Math.floor(value)}M` : value.toFixed(2) + "M";
  } else if (num >= 1000) {
    const value = (num / 1000);
    return value % 1 === 0 ? `${Math.floor(value)}K` : value.toFixed(2) + "K";
  } else {
    const value = Number(num.toFixed(2));
    return value % 1 === 0 ? Math.floor(value).toString() : value.toString();
  }
}